const sharedProps = {
  contact: {
    agentLandingPageUrl: '/agent/6760',
    displayEmail: 'hello@example.com',
    displayPhone: '555-555-5555',
    displayPhotoUrl: 'https://online.sibcycline.com/photos/size/agents/6760/528.jpg',
    displayPrimary: 'Michelle King Heusinkveld',
    displaySecondary: 'Executive Sales Vice President',
    displayWebsiteUrl: 'https://mking.agents.sibcycline.com/',
    designations: 'ABR, CMS, SFR, SRS',
    individualPhotoUrl: 'https://online.sibcycline.com/photos/size/agents/6760/528.jpg',
    isIndianaLicensed: true,
    isKentuckyLicensed: true,
    isOhioLicensed: true,
    languages: 'Syrian, Arabic, Lebanese'
  },
  imageDimensions: { height: 732, width: 528 },
  hasTour: false,
  onListingPage: false,
  showLicensedIn: false,
  setModalIsOpen: () => {}
};

export default {
  horizontalLarge: {
    ...sharedProps,
    theme: 'horizontalLarge'
  },
  horizontalSmall: {
    ...sharedProps,
    onListingPage: true,
    theme: 'horizontalSmall'
  },
  horizontalSmallStacked: {
    ...sharedProps,
    onListingPage: true,
    theme: 'horizontalSmallStacked'
  },
  officeDetail: {
    ...sharedProps,
    theme: 'officeDetail'
  },
  primary: {
    ...sharedProps,
    theme: 'primary'
  },
  props: {
    ...sharedProps
  }
};
